export interface EmbeddingConfig {
  readonly model: string;
  readonly batchSize: number;
  readonly dtype: 'fp32' | 'fp16' | 'q8' | 'q4';
  readonly pooling: 'mean' | 'cls' | 'none';
  readonly normalize: boolean;
  readonly queryPrefix: string;
  readonly docPrefix: string;
  readonly maxInFlightBatches: number;
}

export interface IndexingConfig {
  readonly concurrency: number;
  readonly chunkSize: number;
  readonly chunkOverlap: number;
  readonly ignorePatterns: readonly string[];
  readonly prependPath: boolean; // Prepend file path to chunks for context
  readonly maxFileSizeBytes: number;
}

export interface SearchConfig {
  readonly defaultMode: 'vector' | 'fts' | 'hybrid';
  readonly defaultLimit: number;
}

export interface CrawlConfig {
  readonly userAgent: string;
  readonly timeout: number;
  readonly maxConcurrency: number;
}

export interface ServerConfig {
  readonly port: number;
  readonly host: string;
}

export interface RerankerConfig {
  readonly enabled: boolean;
  readonly model: string;
  readonly topK: number; // Rerank top-K candidates from initial search
  readonly returnK: number; // Return top-K after reranking
}

export interface AppConfig {
  readonly version: number;
  readonly dataDir: string;
  readonly embedding: EmbeddingConfig;
  readonly indexing: IndexingConfig;
  readonly search: SearchConfig;
  readonly crawl: CrawlConfig;
  readonly server: ServerConfig;
  readonly reranker: RerankerConfig;
}

export const DEFAULT_CONFIG: AppConfig = {
  version: 1,
  dataDir: '.bluera/bluera-knowledge/data',
  embedding: {
    model: 'Snowflake/snowflake-arctic-embed-s',
    batchSize: 32,
    dtype: 'fp32',
    pooling: 'cls',
    normalize: true,
    queryPrefix: 'Represent this sentence for searching relevant passages: ',
    docPrefix: '',
    maxInFlightBatches: 1,
  },
  indexing: {
    concurrency: 4,
    chunkSize: 1000,
    chunkOverlap: 150,
    ignorePatterns: ['node_modules/**', '.git/**', '*.min.js', '*.map'],
    prependPath: false,
    maxFileSizeBytes: 1_048_576, // 1MB
  },
  search: {
    defaultMode: 'hybrid',
    defaultLimit: 10,
  },
  crawl: {
    userAgent: 'BlueraKnowledge/1.0',
    timeout: 30000,
    maxConcurrency: 3,
  },
  server: {
    port: 3847,
    host: '127.0.0.1',
  },
  reranker: {
    enabled: false,
    model: 'Xenova/ms-marco-MiniLM-L-6-v2',
    topK: 20,
    returnK: 10,
  },
};
